// extracted by mini-css-extract-plugin
export var container = "index-module--container--qmpBR";
export var description = "index-module--description--ers72";
export var downCaret = "index-module--downCaret--Cc5+z";
export var heroImage = "index-module--heroImage--l3bxj";
export var imageContainer = "index-module--imageContainer--QrCIS";
export var infoIcon = "index-module--infoIcon--LptZ+";
export var mobileDescription = "index-module--mobileDescription--cRDWs";
export var mobileDescriptionBox = "index-module--mobileDescriptionBox--emy4M";